var React = require('react');

function FbIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".b597aa02-9428-4ba8-ab7d-521a672b8ed1{fill:#fff;}")),React.createElement("title",{"key":1},"fb-icon"),React.createElement("path",{"className":"b597aa02-9428-4ba8-ab7d-521a672b8ed1","d":"M30.08,62.07V36.74h-8.5V26.83h8.5V19.54c0-8.46,5.17-13.07,12.72-13.07a69.87,69.87,0,0,1,7.62.39V15.7H45.2c-4.09,0-4.88,1.95-4.88,4.81v6.32h9.81l-1.27,9.91H40.32V62.07Z","key":2})]);
}

FbIcon.defaultProps = {"id":"ae71945e-8285-40d2-a068-5e68037e224b","data-name":"レイヤー 1","viewBox":"0 0 72 72"};

module.exports = FbIcon;

FbIcon.default = FbIcon;
